import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import type { Product } from '@velasca/types'
import { StampedReviewsDesktopSkeleton } from './components/StampedReviewsDesktopSkeleton'
import { StampedReviewsMobileSkeleton } from './components/StampedReviewsMobileSkeleton'

export const StampedReviews = ({
  productId,
  title,
  handle,
  description,
  url,
  featuredImage,
}: Product): JSX.Element | null => {
  const [ref, inView] = useInView({
    rootMargin: `800px 0px 800px 0px`,
  })

  useEffect(() => {
    if (inView) {
      window.StampedFn?.init()
    }
  }, [inView])

  return (
    <div
      ref={ref}
      id="stamped-main-widget"
      className="stamped-apparel-widget"
      data-widget-style="traditional"
      data-product-id={productId}
      data-name={title}
      data-url={url}
      data-image-url={featuredImage}
      data-description={description}
      data-product-sku={handle}
      data-limit-words="80"
    >
      <StampedReviewsMobileSkeleton />
      <StampedReviewsDesktopSkeleton />
    </div>
  )
}
